// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"5579":"c4c42529","7742":"f1f425a7","8588":"272c8640","9304":"272c8640"}[chunkId] + ".chunk.css";
};